<template>
  <div class="w-100">
    <div class="menu w-100" :class="menuClass">
      <b-card
        @click="
          item.subItems.length > 0
            ? addPathItem(item.item)
            : selectItem(item.item)
        "
        v-for="item in items"
        :key="item.item.id"
        href="#"
        class="p-2 mt-1 mr-1"
        :class="
          selectedItem && selectedItem.id == item.item.id
            ? 'bg-primary text-white'
            : ''
        "
      >
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <i
              class="small fas"
              :class="item.subItems.length ? 'fa-folder' : 'fa-align-left'"
            ></i>
            <span class="ml-2">{{ item.item.type }}</span>
          </div>
          <i
            v-if="item.subItems.length > 0"
            class="fa fa-chevron-right"
            aria-hidden="true"
          ></i>
        </div>
      </b-card>
    </div>
    <group-session-type-picker-tree
      v-for="item in items"
      :key="item.item.id"
      :items="item.subItems"
      :selectedPath="selectedPath"
      @push-path="addPathItem"
      @select-item="selectItem"
      :selectedItem="selectedItem"
      :selectedFolder="
        selectedPath.length - 1 == level &&
          selectedPath[level].id == item.item.id
      "
      :level="level + 1"
    />
  </div>
</template>

<script>
export default {
  name: "GroupSessionTypePickerTree",
  props: ["items", "selectedPath", "selectedFolder", "level", "selectedItem"],
  methods: {
    addPathItem(item) {
      this.$emit("push-path", item);
    },
    selectItem(item) {
      this.$emit("select-item", item);
    }
  },
  computed: {
    menuClass() {
      if (this.selectedFolder) return "menu-show";
      if (this.selectedPath.length - 1 < this.level) return "menu-hide-right";
      return "menu-hide-left";
    }
  }
};
</script>

<style scoped>
.menu {
  height: 0px !important;
  display: none;
  transition: margin-left 1s, visibility 0s;
  z-index: 1;
}
.menu-show {
  margin-left: 0px;
  height: auto !important;
  display: block;
}
.menu-hide-left {
  margin-left: -300px;
}
.menu-hide-right {
  margin-left: 300px;
}
</style>
<style>
.menu .card-body {
  padding: 0px !important;
}
.menu .card:hover {
  cursor: pointer;
}
</style>
